define((require) => {
    "use strict";

    const Backbone                  = require("backbone");
    const Tooltip                   = require("ui/common/Tooltip");
    const template                  = require("ui/editor/email/SendTestEmailButtonView.tpl");
    const AbstractEmailButtonView   = require("ui/editor/email/AbstractEmailButtonView");
    const RecipientsPopupModel      = require("ui/editor/email/RecipientsPopupModel");
    const SendTestEmailContentView  = require("ui/editor/email/SendTestEmailContentView");
    const NotificationBar           = require("editor/ui/notificationbar/NotificationBar");
    const EMAIL_STATES              = require("ui/editor/email/Constants");

    const OverlayView = Backbone.View.extend({

        className: "share-overlay",

        events: {
            "activate": "_activateHandler"
        },

        render() {
            return this;
        },

        _activateHandler() {
            this.model.set("state", EMAIL_STATES.CLOSE);
        }

    }, {

        instance: null,

        show(options) {
            const overlayView = new OverlayView(options);
            overlayView.render().$el.appendTo(window.document.body);
            OverlayView.instance = overlayView;
        },

        remove() {
            if (OverlayView.instance) {
                OverlayView.instance.remove();
                OverlayView.instance = null;
            }
        }
    });


    /**
     * Component representing the Send Test Email button for the <tt>EditorPreviewMenu</tt>.
     *
     * @cfg {experienceModel} model The current experience model.
     * @cfg {viewModel} model The current view model.
     *
     * @see EditorPreviewMenu
     *
     * @class SendTestEmailButtonView
     */
    return AbstractEmailButtonView.extend({
        className: "email-button-container",

        template,

        events: {
            "click @ui.emailBtn": "_openRecipientsModal"
        },

        initialize() {
            this.__super();
            this.recipientsPopupModel = new RecipientsPopupModel({
                emailSliceModel: this.model,
                experienceModel: this.experienceModel
            });

            this.listenTo(this.recipientsPopupModel, "change:state", this._manageModalState);
        },

        _openRecipientsModal(event) {
            if (this.ui.emailBtn.hasClass("disabled")) {
                return;
            }
            const state = this.recipientsPopupModel.get("state") === EMAIL_STATES.OPEN ? EMAIL_STATES.CLOSE : EMAIL_STATES.OPEN;
            // If a open - close, and vice versa
            this.recipientsPopupModel.set({state});
            event.preventDefault();
        },

        _addPopup(tooltipSettings) {
            Tooltip.add(this.ui.popup, tooltipSettings);
            Tooltip.show(this.ui.popup);
            OverlayView.show({model: this.recipientsPopupModel});
        },

        _removePopup() {
            Tooltip.remove(this.ui.popup);
            OverlayView.remove();
        },

        _manageModalState() {
            let notificationId = null;
            NotificationBar.close();
            let tooltipSettings = {
                width: 408,
                animation: false,
                trigger: "manual",
                duration: 0,
                classes: "share-menu-container email modal-popover"
            };
            switch (this.recipientsPopupModel.get("state")) {
                case EMAIL_STATES.OPEN:
                    tooltipSettings.content = new SendTestEmailContentView({model: this.recipientsPopupModel});
                    tooltipSettings.html = true;
                    this._addPopup(tooltipSettings);
                    break;
                case EMAIL_STATES.CLOSE:
                    this._removePopup();
                    this._updateButtonState();
                    break;
                case EMAIL_STATES.PROCESSING_EMAIL:
                    this._removePopup();
                    notificationId = NotificationBar.open("Please wait... Preparing email for sending");
                    break;
                case EMAIL_STATES.SENT_EMAIL:
                    this._removePopup();
                    NotificationBar.close({id: notificationId, clear: "self"});
                    NotificationBar.open("You have successfully sent test email", {closeDelay: 5000});
                    break;
                case EMAIL_STATES.SENT_EMAIL_WITH_SIZE_WARNING:
                    this._removePopup();
                    NotificationBar.close({id: notificationId, clear: "self"});
                    NotificationBar.error("Warning: You have successfully sent test email but your email is larger than 102KB so it will not render properly in Gmail client.");
                    break;
                case EMAIL_STATES.ERROR_EMAIL:
                    this._removePopup();
                    NotificationBar.close({id: notificationId, clear: "self"});
                    NotificationBar.error("Some error occurred while sending email. Please try again", {closeDelay: 5000});
                    break;
                default:
                    break;
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/email/SendTestEmailButtonView.js